<template>
  <div class="container" id="app">
    <div class="app">
      <router-view v-if="web3Exist"></router-view>
      <div v-else>
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <path style="fill:#ADEBFF;" d="M304.489,413.234c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.19,54.879
              l6.323,18.966c26.517-26.517,61.11-60.797,61.457-61.14C307.939,422.406,307.965,416.743,304.489,413.234z"/>
          <path style="fill:#51E9D3;" d="M304.489,372.99c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.191,54.88
              l6.324,18.965c26.517-26.517,61.11-60.797,61.457-61.14C307.939,382.161,307.965,376.499,304.489,372.99z"/>
          <path style="fill:#E0F4B4;" d="M322.135,85.486V99.65l-85.486,119.023L203.112,93.158L236.649,0
              C283.869,0,322.135,38.277,322.135,85.486z"/>
          <path style="fill:#51E9D3;" d="M189.865,46.784v327.3c0,25.846,15.483,35.069,46.784,66.37V0
              C210.814,0,189.865,20.95,189.865,46.784z"/>
          <polygon style="fill:#51A978;" points="322.135,99.65 322.135,212.838 236.649,331.861 236.649,185.136 "/>
          <path style="fill:#3AC099;" d="M322.135,212.838v66.113c0,47.209-28.283,64.056-85.486,121.259V298.324L322.135,212.838z"/>
          <path style="fill:#80086E;" d="M236.65,512c-4.939,0-8.943-4.004-8.943-8.943V33.537c0-4.939,4.004-8.943,8.943-8.943
              c4.939,0,8.943,4.004,8.943,8.943v469.52C245.593,507.996,241.59,512,236.65,512z"/>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
        </svg>

        <h2>このサービスの利用にはブラウザウォレットMetamaskが必要です。</h2>
        <p>
          <a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=ja">こちら</a>からインストールをお願いします
        </p>
      </div>

      <div class="footer">
        <p>
          Unchainは京都からアプリ・Webサービス開発を行う <a href="https://clickan.click" title="Clickan">Clickan</a> によって開発・運営されています。
        </p>
        <p>
          不具合の連絡は y.doi[at]clickan.click までお願いします。
        </p>
        <p>Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GiftForm from './components/GiftForm'
  import GiftSent from './components/GiftSent'
  import GiftReceive from './components/GiftReceive'

  export default {
    components: {
      GiftForm,
      GiftSent,
      GiftReceive
    },
    computed: {
      ...mapGetters([
        'sendGiftSucceeded'
      ])
    },
    data () {
      return {
        web3Exist: window.web3 !== null
      }
    }
  }
</script>

<style lang="scss">
  .container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .app {
    color: #2c3e50;
    text-align: center;
    margin: 32px;
    width: 90%;
  }

  h1, h2 {
    font-weight: normal;
    margin: 16px 0;
  }

  body {
    background-color: #F8FAFF;
  }

  p {
    line-height: 32px;
  }

  svg {
    width: 84px;
  }

  .footer {
    margin-top: 64px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue